import React from 'react';

const JS_Dates = () => {
  return (
    <div >
      <h1>JS_Dates</h1>
      <p>Placeholder component for: "JS Dates"</p>
    </div>
  );
};

export default JS_Dates;
